/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import type { SVGProps } from 'react';

export type IllustrationSizeVariants =
  | 'small'
  | 'medium'
  | 'large'
  | 'xlarge'
  | 'xxlarge'
  | 'xxxlarge'
  | 'xxxxlarge';
export type IllustrationProps = {
  width?: number | string;
  height?: number | string;
  size?: IllustrationSizeVariants;
};
const IllustrationEmptyStateInfo = ({
  size = 'medium',
  width,
  height,
  ...props
}: IllustrationProps) => {
  let presetWidth: string | undefined;
  let presetHeight: string | undefined;
  const presets = {
    small: '48px',
    medium: '68px',
    large: '92px',
    xlarge: '122px',
    xxlarge: '156px',
    xxxlarge: '194px',
    xxxxlarge: '236px',
  };
  if (size) {
    presetWidth = presets[size];
    presetHeight = presets[size];
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 68 68"
      data-xds="IllustrationEmptyStateInfo"
      height={height || presetHeight}
      role="presentation"
      width={width || presetWidth}
      {...props}
    >
      <path
        fill="#DBE2E6"
        fillRule="evenodd"
        d="M61.475 32.447c0 15.984-12.958 28.942-28.942 28.942S3.591 48.43 3.591 32.447 16.55 3.505 32.533 3.505s28.942 12.958 28.942 28.942"
        clipRule="evenodd"
      />
      <path
        fill="#5E737D"
        fillRule="evenodd"
        d="M54.313 13.6c6.178 5.309 10.095 13.172 10.095 21.954 0 15.984-12.958 28.942-28.942 28.942-8.783 0-16.646-3.917-21.954-10.094a28.82 28.82 0 0 0 18.847 6.987c15.984 0 28.942-12.957 28.942-28.941A28.82 28.82 0 0 0 54.313 13.6m-19.29 12.917v22.154h-5.868V26.517zm-3.132-10.012a3.302 3.302 0 1 1-.001 6.603 3.302 3.302 0 0 1 .002-6.603"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default IllustrationEmptyStateInfo;
